const TENANT_ACTIONS = {
  SET_TENANT: 'SET_TENANT',
};
export default TENANT_ACTIONS;
